import type * as React from 'react'
import { Navigation } from 'lucide-react'

import { cn } from '@/shared/ui/cn'

type MapsDirectionsLinkProps = {
  latitude?: number | null
  longitude?: number | null
  className?: string
  children?: React.ReactNode
}

function isCoordinate(value: number | null | undefined): value is number {
  return typeof value === 'number' && Number.isFinite(value)
}

function MapsDirectionsLink({ latitude, longitude, className, children }: MapsDirectionsLinkProps) {
  if (!isCoordinate(latitude) || !isCoordinate(longitude)) return null

  return (
    <a
      href={`https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'inline-flex items-center gap-1.5 text-sm font-medium text-primary hover:underline',
        className,
      )}
    >
      <Navigation aria-hidden className="size-4" />
      {children ?? 'Directions'}
    </a>
  )
}

export { MapsDirectionsLink }
export type { MapsDirectionsLinkProps }
